import { StorageKey } from "@app/constants";

export function setItem(key: StorageKey, value: any) {
  return localStorage.setItem(key, JSON.stringify(value));
}

export function getItem(key: StorageKey) {
  try {
    return JSON.parse(localStorage.getItem(key) || "null");
  } catch (e) {
    throw e;
  }
}

export function removeItem(key: StorageKey) {
  return localStorage.removeItem(key);
}
